<template>
  <div class="hamburger-wrapper">
    <div class="hamburger" :class="{ open: isOpen }" :onClick="onClick">
      <div class="hamburger-line hamburger-line1"></div>
      <div class="hamburger-line hamburger-line2"></div>
      <div class="hamburger-line hamburger-line3"></div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

let isOpen = ref(false);

const onClick = () => {
  isOpen.value = !isOpen.value;
};
</script>

<style lang="scss" scoped>
.hamburger-wrapper {
  padding: 10px 0 10px 10px;
  z-index: 100;
}

.hamburger {
  width: 2rem;
  height: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  background-color: inherit;
}

.hamburger-line {
  width: 100%;
  height: 0.25rem;
  background-color: var(--white);
  transition:
    transform 0.3s ease,
    opacity 0.3s ease;
}

.open {
  transform: translateX(0.5rem);

  .hamburger-line1 {
    transform: rotate(45deg) translateY(0.875rem);
  }

  .hamburger-line2 {
    opacity: 0;
  }

  .hamburger-line3 {
    transform: rotate(-45deg) translateY(-0.875rem);
  }
}
</style>
